var $ = require('jQuery');
var Audio = require('../../lib/audio.js');
var Cards = require('../../lib/cards.js');
var stickybits = require('../../vendor/stickybits/jquery.stickybits.js');
var tectoastr = require('tectoastr');
var VideoPlayer = require('../../lib/video-player.js');
var VideoModal = require('../../lib/video-modal.js');
var VideoThumbnails = require('../../lib/video-thumbnails.js');
var isMobile = require('../../lib/navigation-is-mobile.js');
var store = require('../../lib/store/index.js').default;

const Vue = require('vue');
const Preferences = require('./Preferences/Preferences.vue').default;


module.exports = function()
{
    /**
     * Cards
     */
    var cards = new Cards;
    cards.setup('ul.cards', 'li', 'fitRows');

    /**
     * Audio
     */
    var audio = new Audio;
    audio.setup('jp-jplayer');

    /**
     * Video
     */
    var videoPlayer = new VideoPlayer;
    var videoModal = new VideoModal;
    var videoThumbnails = new VideoThumbnails;

    videoPlayer.setup('video-js-standalone');
    videoModal.setup('play-video');
    videoThumbnails.setup('preview-container.video');

    const rows = document.querySelectorAll('.preferences');

    [].forEach.call(rows , (el) => {
      new Vue({
        el: el,
        components: {
          'preferences': Preferences
        },
        store
      });
    });

    if (!isMobile()) {
        $('.header-controls').stickybits({
            useStickyClasses: true
        });
    }
};
